module.exports = __webpack_public_path__ + "img/3-6.15eec988.svg";